export const CREATE_TAG = 'CREATE_TAG'; // Новый тег
export const GET_TAGS = 'GET_TAGS'; // получить теги определенного модуля
export const SAVE_TAG = 'SAVE_TAG'; // сохранить тег (цвет. Название наверно нельзя менять)
export const ATTACH_TAG = 'ATTACH_TAG'; // привязать тег к объекту
export const DETACH_TAG = 'DETACH_TAG'; // убрать тег из списка в объекте
export const DELETE_TAG = 'DELETE_TAG'; // удалить тег вообще из всех объектов
